import en from './jsons/en.json';
import de from './jsons/de.json';
export const dictionaryList = { en, de };
export const languageOptions = {
  en: 'EN',
  de: 'DE'
};